import styled from "styled-components"

export const StatusTabeCart = styled.div<{active:boolean}>`
    height: 5rem;
    width: 16.5rem;
    display: flex;
    align-items: center;
    color: ${({active})=>active ? 'var(--white)' : 'var(--text)'};
    background-color: ${({active})=>active ? 'var(--primary)': 'var(--light-gray)'};
    border-radius: 1rem;
    cursor: pointer;
    @media (max-width: 768px) {
        width: 48%;
    }
    @media (max-width: 690px) {
        width: 100%;
    }
    
    h2{
        width: 100%;
        text-align: center;
        font-size: 1.6rem;
    }


`